// Payment methods whose amount may not exceed the balance. A card charge above
// the balance overcharges the customer; a gift card or customer credit
// redemption above it wastes stored value. Every other method (cash, POS
// payment, Yappy, custom methods) records money already received, so it may
// exceed the balance and the negative due is the change owed back.
export const CAPPED_PAYMENT_METHODS = ['Card', 'Gift card', 'Customer credit']

export function allowsOverpayment(methodName) {
  return !CAPPED_PAYMENT_METHODS.includes(methodName)
}
